import React, { useState, useEffect } from "react";
import { Input, Form, Switch, Dropdown, Checkbox, Select } from "antd";
import { useNavigate } from "react-router-dom";
import columns from "../../columns/Subadmin.js";
import ConfirmationModal from "../../components/global/modal/ConfirmationModal.jsx";
import TableWithSkeleton from "../../components/global/table/TableWithSkeleton.jsx";
import ModalComponent from "../../components/global/modal/ModalComponent.jsx";
import Edit from "../../assets/Edit.jsx";
import {
  AddSubadmin,
  GetAllSubadmin,
  DeactiveUser,
  DeleteSubadmin,
  ChangePasswordApi,
  GetAllOffices,
  GetAllTeamLeaders,
} from "../../api/request/subadmin.js";
import toast from "react-hot-toast";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import moment from "moment";
import UserAvatar from "../../components/global/avtar/UserAvatar.jsx";
import Lock from "../../assets/auth/Lock.jsx";
import Setting from "../../assets/Setting.jsx";
import useModulePermissions from "../../hooks/useModulePermissions.jsx";

const departmentOptions = [
  { label: "Sales", value: 1 },
  { label: "Management", value: 2 },
  { label: "BackOffice", value: 3 },
  { label: "Support", value: 4 },
];

const SALES_DEPARTMENT_VALUE = 1;

const normalizeDepartmentValue = (department) => {
  if (typeof department === "number") return department;
  if (!department) return undefined;
  const normalized = String(department).replace(/\s+/g, "").toLowerCase();
  const match = departmentOptions.find(
    (opt) => opt.label.replace(/\s+/g, "").toLowerCase() === normalized,
  );
  return match?.value;
};

const getDepartmentLabel = (department) => {
  const value = normalizeDepartmentValue(department);
  return (
    departmentOptions.find((opt) => opt.value === value)?.label ||
    department ||
    "--"
  );
};

export default function Subadmin() {
  const subadminPermissions = useModulePermissions("subadmin");
  const canCreate = !!subadminPermissions.create;
  const canUpdate = !!subadminPermissions.update;
  const canDelete = !!subadminPermissions.delete;
  const canChangePassword = !!subadminPermissions.change_password;
  const canUpdatePermission = !!subadminPermissions.update_permission;

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [changePasswordForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isAddSubadminLoading, setIsAddSubadminLoading] = useState(false);
  const [isAddSubadmin, setIsAddSubadmin] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedSubadmin, setSelectedSubadmin] = useState(null);
  const [isStatusConfirmOpen, setIsStatusConfirmOpen] = useState(false);
  const [isStatusConfirmLoading, setIsStatusConfirmLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedsubid, setSelectedSub] = useState(null);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [isPasswordLoading, setIsPasswordLoading] = useState(false);
  const [initialChangePasswordValue, setInitialChangePasswordValue] = useState({
    password: "",
    confirmPassword: "",
  });
  const [offices, setOffices] = useState([]);
  const [salesTeams, setSalesTeams] = useState([]);
  const [selectedOffices, setSelectedOffices] = useState([]);
  const [isTeamLeader, setIsTeamLeader] = useState(false);

  const departmentValue = Form.useWatch("department", form);
  const isSalesDepartment =
    normalizeDepartmentValue(departmentValue) === SALES_DEPARTMENT_VALUE;

  const statusHandler = async (role) => {
    setSelectedSub(role);
    setIsStatusConfirmOpen(true);
  };

  const getSubadmin = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetAllSubadmin();
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: (
                <UserAvatar
                  data={{
                    name: `${item?.firstName} ${item?.lastName}`,
                    email: item?.email,
                  }}
                />
              ),
              createdDate: moment(item?.createdDate).format("DD-MM-YYYY, LT"),
              department: getDepartmentLabel(item?.department),
              office: item?.office || "--",
              teamLeader: item?.teamLeader || "--",
              status: (
                <Switch
                  disabled={!canUpdate}
                  onChange={canUpdate ? () => statusHandler(item) : undefined}
                  checkedChildren="On"
                  unCheckedChildren="Off"
                  checked={item?.isActive}
                />
              ),
              actions:
                canChangePassword ||
                canUpdatePermission ||
                canUpdate ||
                canDelete ? (
                  <div className="flex items-center gap-2">
                    {(canChangePassword || canUpdatePermission) && (
                      <Dropdown
                        menu={{
                          items: [
                            canChangePassword && {
                              key: "change-password",
                              label: (
                                <div
                                  onClick={() => changePasswordHandler(item)}
                                >
                                  Change Password
                                </div>
                              ),
                            },
                            canUpdatePermission && {
                              key: "change-permission",
                              label: (
                                <div
                                  onClick={() => changePermissionHandler(item)}
                                >
                                  Change Permission
                                </div>
                              ),
                            },
                            !item?.isSubAdminViewAllClients && {
                              key: "assigned-to-sales",
                              label: (
                                <div
                                  onClick={() =>
                                    navigate(
                                      `/assigned_to_sales/${item?.userId}`,
                                    )
                                  }
                                >
                                  Assigned To Sales
                                </div>
                              ),
                            },
                          ].filter(Boolean),
                        }}
                        placement="bottomLeft"
                        arrow
                        trigger={["click"]}
                      >
                        <div className="cursor-pointer">
                          <Setting />
                        </div>
                      </Dropdown>
                    )}
                    {canUpdate && (
                      <button
                        // className={`${item?.roleName === "TeamMember" ? "" : "opacity-50 cursor-not-allowed"}`}
                        // disabled={item?.roleName !== "TeamMember"}
                        onClick={(e) => openEditHandler(item)}
                      >
                        <Edit />
                      </button>
                    )}
                    {canDelete && (
                      <button
                        onClick={() => {
                          setIsDelete(true);
                          setDeleteId(item?.userId);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="#D91819"
                          className="w-6 h-6 cursor-pointer hover:stroke-[#aa0001] duration-500"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                ) : null,
            };
          }),
        );
      }
      setTotalRecord(data?.totalRecords || 0);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleDelete = async (id) => {
    setIsLoading(true);
    try {
      const { data } = await DeleteSubadmin(id);
      if (data?.success) {
        toast.success(data?.message);
        setIsDelete(false);
        getSubadmin();
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsLoading(false);
    }
  };
  const handleChangePassword = async (values) => {
    const { password, confirmPassword } = values;
    const params = { userId: selectedUserId, password, confirmPassword };
    if (password !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }
    try {
      setIsPasswordLoading(true);
      const { data } = await ChangePasswordApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setIsPasswordLoading(false);
      } else {
        toast.error(data?.message);
        setIsPasswordLoading(false);
      }
      setIsChangePassword(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsPasswordLoading(false);
      setIsChangePassword(false);
    }
  };
  const changePasswordHandler = (subAdminDetails) => {
    setSelectedUserId(subAdminDetails?.userId);
    setIsChangePassword(true);
  };
  const changePermissionHandler = (subAdminDetails) => {
    navigate(`/sub_admin/${subAdminDetails?.userId}`);
  };
  useEffect(() => {
    if (!isChangePassword) {
      form.resetFields();
      setInitialChangePasswordValue({ password: "", confirmPassword: "" });
    }
  }, [isChangePassword]);
  const statusChangeConfirm = async () => {
    try {
      setIsStatusConfirmLoading(true);

      const { data } = await DeactiveUser({
        userId: selectedsubid?.userId,
        isActive: !selectedsubid?.isActive,
      });
      if (data?.success) {
        getSubadmin();
        toast.success(data?.message);
      } else {
        toast.error(data?.message);
      }

      setIsStatusConfirmLoading(false);
      setIsStatusConfirmOpen(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsStatusConfirmLoading(false);
    }
  };

  const handleSubmit = async (value) => {
    try {
      setIsAddSubadminLoading(true);
      const isSales =
        normalizeDepartmentValue(value?.department) === SALES_DEPARTMENT_VALUE;
      const payload = {
        ...value,
        department: normalizeDepartmentValue(value?.department),
        teamLeadId: isSales && !value?.isTeamLeader ? value?.teamLeadId : null,
        isTeamLeader: isSales ? !!value?.isTeamLeader : false,
        ...(isUpdate && { id: selectedSubadmin?.userId }),
      };

      if (isSales) {
        payload.primaryOfficeId = value?.primaryOfficeId || null;
        payload.officeIds = Array.isArray(value?.officeIds)
          ? value.officeIds
          : [];
      } else {
        payload.officeIds = Array.isArray(value?.officeIds)
          ? value.officeIds
          : [];
        delete payload.primaryOfficeId;
      }

      const { data } = await AddSubadmin(payload);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setIsAddSubadminLoading(false);
        setIsAddSubadmin(false);
        setIsUpdate(false);
        setSelectedSubadmin(null);
        getSubadmin();
      } else {
        toast.error(data?.message);
        setIsAddSubadminLoading(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsAddSubadminLoading(false);
    }
  };

  useEffect(() => {
    getSubadmin();
  }, [canUpdate, canDelete, canChangePassword, canUpdatePermission]);

  useEffect(() => {
    const fetchOffices = async () => {
      try {
        const { data } = await GetAllOffices();
        setOffices(data?.data || []);
      } catch (error) {
        toast.error(
          error?.response?.data?.error?.message || "Failed to load offices.",
        );
      }
    };
    fetchOffices();
  }, []);

  useEffect(() => {
    const fetchTeams = async () => {
      if (selectedOffices.length > 0) {
        try {
          const results = await Promise.all(
            selectedOffices.map((officeId) => GetAllTeamLeaders(officeId)),
          );
          const allTeams = results.flatMap((res) => res.data?.data || []);
          const uniqueTeams = allTeams.filter(
            (team, idx, self) =>
              idx === self.findIndex((t) => t.userId === team.userId),
          );
          setSalesTeams(uniqueTeams);
        } catch (error) {
          toast.error(
            error?.response?.data?.error?.message ||
              "Failed to load team leaders.",
          );
        }
      } else {
        setSalesTeams([]);
      }
    };
    fetchTeams();
  }, [selectedOffices]);

  useEffect(() => {
    if (!isAddSubadmin) {
      form.resetFields();
      setIsUpdate(false);
      setSelectedSubadmin(null);
      setSelectedOffices([]);
      setIsTeamLeader(false);
    }
  }, [isAddSubadmin]);

  const openEditHandler = (subadmin) => {
    const deptValue = normalizeDepartmentValue(subadmin?.department);
    const isSales = deptValue === SALES_DEPARTMENT_VALUE;
    const officeIds = subadmin?.officeIds || [];
    setSelectedOffices(
      isSales
        ? subadmin?.primaryOfficeId
          ? [subadmin.primaryOfficeId]
          : []
        : officeIds,
    );
    setIsTeamLeader(!!subadmin?.isTeamLeader);
    form.setFieldsValue({
      firstName: subadmin?.firstName,
      lastName: subadmin?.lastName,
      email: subadmin?.email,
      phoneNo: subadmin?.phoneNo,
      isSubAdminViewAllClients: !!subadmin?.isSubAdminViewAllClients,
      department: deptValue,
      teamLeadId: isSales ? subadmin?.teamLeaderId || undefined : null,
      isTeamLeader: !!subadmin?.isTeamLeader,
      ...(isSales
        ? {
            primaryOfficeId: subadmin?.primaryOfficeId || undefined,
            officeIds,
          }
        : { officeIds }),
    });
    setSelectedSubadmin(subadmin);
    setIsUpdate(true);
    setIsAddSubadmin(true);
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:justify-end">
        <div className="flex">
          {canCreate && (
            <div>
              <button
                className="export-btm flex items-center gap-2 bg-primary text-sm text-white font-medium capitalize px-9 py-2 rounded-lg themeHover  duration-400"
                onClick={() => {
                  setIsUpdate(false);
                  setSelectedSubadmin(null);
                  form.resetFields();
                  setIsAddSubadmin(true);
                }}
                size="large"
              >
                <img
                  src="assets/icons/add_icon.svg"
                  alt="icon"
                  className=" "
                  width={12}
                />
                <span> Add Subadmin</span>
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            hiddenColumns={
              !canUpdate &&
              !canDelete &&
              !canChangePassword &&
              !canUpdatePermission
                ? ["Actions"]
                : []
            }
          />
        </div>
      </div>

      <ConfirmationModal
        isOpen={isStatusConfirmOpen}
        setIsOpen={setIsStatusConfirmOpen}
        message="Are you sure to change the Subadmin status?"
        onConfirm={statusChangeConfirm}
        isLoading={isStatusConfirmLoading}
        loadingLabel="Changing status..."
      />

      {/* Add / Edit subadmin */}
      <ModalComponent
        isOpen={isAddSubadmin}
        setIsOpen={setIsAddSubadmin}
        title={
          <div className="font-bold text-lg">
            {isUpdate ? "Edit Sub Admin" : "Add Sub Admin"}
          </div>
        }
        onCancel={() => setIsAddSubadmin(false)}
        width={800}
      >
        <Form
          className="w-full"
          autoComplete="off"
          form={form}
          onFinish={handleSubmit}
        >
          <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-5">
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                First Name
              </label>
              <Form.Item
                name="firstName"
                rules={[
                  { required: true, message: "Please enter first name." },
                ]}
              >
                <Input placeholder="First name" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                Last Name
              </label>
              <Form.Item
                name="lastName"
                rules={[{ required: true, message: "Please enter last name." }]}
              >
                <Input placeholder="Last name" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                Primary Email
              </label>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Please enter valid email.",
                  },
                ]}
              >
                <Input
                  placeholder="Primary email"
                  className="mt-1 w-full py-2"
                />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                Phone No.
              </label>
              <Form.Item
                name="phoneNo"
                rules={[
                  {
                    required: true,
                    message: "Please enter valid phone number.",
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder="Phone no."
                  className="mt-1 w-full py-2"
                />
              </Form.Item>
            </div>
            <div className="input-white ant-select-selector-white ant-multi-select-selector">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                Department
              </label>
              <Form.Item
                name="department"
                rules={[
                  { required: true, message: "Please select department." },
                ]}
              >
                <Select
                  // mode="multiple"
                  placeholder="Select department"
                  className="mt-1 !h-[40px] w-full"
                  options={departmentOptions}
                  onChange={(val) => {
                    const isSwitchingToSales =
                      normalizeDepartmentValue(val) === SALES_DEPARTMENT_VALUE;
                    if (isSwitchingToSales) {
                      const currentOffices = form.getFieldValue("officeIds");
                      const firstOffice = Array.isArray(currentOffices)
                        ? currentOffices[0]
                        : currentOffices;
                      form.setFieldsValue({
                        primaryOfficeId: firstOffice || undefined,
                        officeIds: [],
                      });
                      setSelectedOffices(firstOffice ? [firstOffice] : []);
                    } else {
                      const primaryOffice =
                        form.getFieldValue("primaryOfficeId");
                      const secondaryOffices =
                        form.getFieldValue("officeIds") || [];
                      const merged = primaryOffice
                        ? [primaryOffice, ...secondaryOffices]
                        : secondaryOffices;
                      form.setFieldsValue({
                        officeIds: merged,
                        primaryOfficeId: undefined,
                        teamLeadId: null,
                        isTeamLeader: false,
                      });
                      setSelectedOffices(merged);
                      setIsTeamLeader(false);
                    }
                  }}
                />
              </Form.Item>
            </div>

            {isSalesDepartment ? (
              <>
                <div className="input-white ant-select-selector-white ant-multi-select-selector">
                  <label className="text-description text-[#2F2B3DCC] font-medium">
                    Primary Office
                  </label>
                  <Form.Item
                    name="primaryOfficeId"
                    rules={[
                      { required: true, message: "Please select office." },
                    ]}
                  >
                    <Select
                      placeholder="Select office"
                      className="mt-1 w-full !h-[40px]"
                      onChange={(val) => {
                        setSelectedOffices(val ? [val] : []);
                        form.setFieldValue("teamLeadId", null);
                      }}
                      options={offices.map((office) => ({
                        label: office.officeName,
                        value: office.id,
                      }))}
                    />
                  </Form.Item>
                </div>
                <div className="input-white ant-select-selector-white ant-multi-select-selector">
                  <label className="text-description text-[#2F2B3DCC] font-medium">
                    Secondary Offices
                  </label>
                  <Form.Item name="officeIds">
                    <Select
                      mode="multiple"
                      placeholder="Select secondary offices"
                      className="mt-1 w-full"
                      options={offices.map((office) => ({
                        label: office.officeName,
                        value: office.id,
                      }))}
                    />
                  </Form.Item>
                </div>
              </>
            ) : (
              <div className="input-white ant-select-selector-white ant-multi-select-selector">
                <label className="text-description text-[#2F2B3DCC] font-medium">
                  Offices
                </label>
                <Form.Item
                  name="officeIds"
                  rules={[{ required: true, message: "Please select office." }]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select offices"
                    className="mt-1 w-full"
                    onChange={(val) => {
                      setSelectedOffices(val || []);
                      form.setFieldValue("teamLeadId", null);
                    }}
                    options={offices.map((office) => ({
                      label: office.officeName,
                      value: office.id,
                    }))}
                  />
                </Form.Item>
              </div>
            )}

            {isSalesDepartment && (
              <div className="flex items-end">
                <Form.Item
                  name="isTeamLeader"
                  valuePropName="checked"
                  initialValue={false}
                  className="mb-0"
                >
                  <Checkbox
                    onChange={(e) => {
                      setIsTeamLeader(e.target.checked);
                      if (e.target.checked) {
                        form.setFieldValue("teamLeadId", null);
                      }
                    }}
                  >
                    Team Leader
                  </Checkbox>
                </Form.Item>
              </div>
            )}

            {isSalesDepartment && !isTeamLeader && (
              <div className="input-white ant-select-selector-white">
                <label className="text-description text-[#2F2B3DCC] font-medium">
                  Team Leader
                </label>
                <Form.Item
                  name="teamLeadId"
                  rules={[
                    {
                      required: isSalesDepartment && !isTeamLeader,
                      message: "Please select team leader.",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select team leader"
                    className="mt-1 w-full !h-[40px]"
                    disabled={selectedOffices.length === 0}
                    options={salesTeams.map((team) => ({
                      label: `${team.fullName} (${team.email})`,
                      value: team.userId,
                    }))}
                  />
                </Form.Item>
              </div>
            )}

            <div className="flex items-end">
              <Form.Item
                name="isSubAdminViewAllClients"
                valuePropName="checked"
                initialValue={false}
                className="mb-0"
              >
                <Checkbox className="text-[#2F2B3DCC]">
                  View All Clients
                </Checkbox>
              </Form.Item>
            </div>
          </div>
          <div className="flex justify-end mt-8">
            <LoadableButton
              className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
              disabled={isAddSubadminLoading}
              type="Submit"
              lable="Submit"
              isLoading={isAddSubadminLoading}
              loadingLable={`${isUpdate ? "Updating" : "Adding"} subadmin...`}
            />
          </div>
        </Form>
      </ModalComponent>

      <ConfirmationModal
        isOpen={isDelete}
        setIsOpen={setIsDelete}
        message="Are you sure, you want to delete ?"
        isLoading={isLoading}
        loadingLabel="Removing..."
        onConfirm={() => handleDelete(deleteId)}
      />
      <ModalComponent
        isOpen={isChangePassword}
        setIsOpen={setIsChangePassword}
        title="Change Password"
      >
        <Form
          autoComplete="off"
          initialValues={initialChangePasswordValue}
          onFinish={handleChangePassword}
          form={changePasswordForm}
        >
          <div className="p-5 grid grid-cols-1 gap-6">
            <div>
              <p className="mb-1">New Password</p>
              <Form.Item
                name="password"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please input your new password!",
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="New Password"
                  prefix={<Lock />}
                />
              </Form.Item>
            </div>
            <div>
              <p className="mb-1">Confirm Password</p>
              <Form.Item
                dependencies={["password"]}
                hasFeedback
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: "Please confirm your new password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The new password that you entered do not match!",
                        ),
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="Confirm Password"
                  prefix={<Lock />}
                />
              </Form.Item>
            </div>
            <div>
              <LoadableButton
                type="submit"
                className="w-full text-base font-medium py-2 px-2 rounded-lg text-white bg-primary themeHover"
                lable="Change Password"
                isLoading={isPasswordLoading}
                loadingLable="Updating..."
              />
            </div>
          </div>
        </Form>
      </ModalComponent>
    </div>
  );
}
